<template>
    <div>
        <el-form-item label="Formularz" required
                      :error="errors['form']">
            <el-select filterable v-model="form.form" placeholder="Wybierz formularz">
                <el-option v-for="folder in forms"
                           :key="folder.id"
                           :label="folder.name_pl"
                           :value="folder.id"/>
            </el-select>
        </el-form-item>
    </div>
</template>
<script>
    import {CustomForm} from '@/api'

    export default {
        props: ['form', 'errors'],
        data () {
            return {
                forms: []
            }
        },
        methods: {
            fetchData () {
                CustomForm.all().then(response => {
                    this.forms = response.data
                })
            }
        },
        mounted () {
            this.fetchData()
        }
    }
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// FormWidget.vue?cea6aa7c